import { INVALID_RANGE, reviewFilters, reviewFiltersHeadings, SELECT_FIELD_DATE, TransferDateFieldEnum } from "@/utils/constants";
import { Checkbox, CheckboxGroup, Grid, GridItem, Stack, Text, Box, Button } from "@chakra-ui/react"
import { getHideUnnecessaryRejectionValue, getLicenseApprovalFilterModel } from "../components/selector";
import { useDispatch } from "react-redux";
import { setHideUnnecessaryRejection, setLicenseApprovalFilterModel } from "../ducks/slice";
import { CalendarDate } from '@internationalized/date';
import { DateValue } from "react-aria";
import { useEffect, useState } from "react";
import FlatDatePickr from "@/common/Flatpickr";

interface Props {
    item?: string;
}

export const LicenseApprovalFilters = ({ item = "" }: Props) => {
    const [transferDateError, setTransferDateError] = useState('');
    const dispatch = useDispatch();
    const licenseApprovalFilterModel:any = getLicenseApprovalFilterModel();
    const hideUnnecessaryRejection = getHideUnnecessaryRejectionValue()
    const reviewedStatusOption = reviewFilters.status.find((val: any) => val.value === "reviewed");

    const handleFilterValues = (value: string, isChecked: boolean, filterType: string) => {
        if (filterType === reviewFiltersHeadings.status) {
            const updatedFilters = !isChecked ?
                licenseApprovalFilterModel.status.values.includes(value)
                    ? licenseApprovalFilterModel.status.values
                    : [...licenseApprovalFilterModel.status.values, value]
                : licenseApprovalFilterModel.status.values.filter((val:any) => val !== value)
            dispatch(setLicenseApprovalFilterModel({
                ...licenseApprovalFilterModel,
                status: {
                    ...licenseApprovalFilterModel.status,
                    values: updatedFilters
                }
            }));
        } else if (filterType === reviewFiltersHeadings.faildSteps) {
            const updatedFilters = !isChecked ?
                licenseApprovalFilterModel.faildSteps.values.includes(value)
                    ? licenseApprovalFilterModel.faildSteps.values
                    : [...licenseApprovalFilterModel.faildSteps.values, value]
                : licenseApprovalFilterModel.faildSteps.values.filter((val:any) => val !== value)
            dispatch(setLicenseApprovalFilterModel({
                ...licenseApprovalFilterModel,
                faildSteps: {
                    ...licenseApprovalFilterModel.faildSteps,
                    values: updatedFilters
                }
            }));
        } else if (filterType === reviewFiltersHeadings.source) {
            const updatedFilters = !isChecked ?
                licenseApprovalFilterModel.source.values.includes(value)
                    ? licenseApprovalFilterModel.source.values
                    : [...licenseApprovalFilterModel.source.values, value]
                : licenseApprovalFilterModel.source.values.filter((val:any) => val !== value)
            dispatch(setLicenseApprovalFilterModel({
                ...licenseApprovalFilterModel,
                source: {
                    ...licenseApprovalFilterModel.source,
                    values: updatedFilters
                }
            }));
        } else if (filterType === reviewFiltersHeadings.storeType) {
            const updatedFilters = !isChecked ?
                licenseApprovalFilterModel.storeType.values.includes(value)
                    ? licenseApprovalFilterModel.storeType.values
                    : [...licenseApprovalFilterModel.storeType.values, value]
                : licenseApprovalFilterModel.storeType.values.filter((val:any) => val !== value)
            dispatch(setLicenseApprovalFilterModel({
                ...licenseApprovalFilterModel,
                storeType: {
                    ...licenseApprovalFilterModel.storeType,
                    values: updatedFilters
                }
            }));
        } else if (filterType === reviewFiltersHeadings.manualReview) {
            const updatedFilters = !isChecked ?
            licenseApprovalFilterModel.isManuallyRequested.values.includes(value)
            ? licenseApprovalFilterModel.isManuallyRequested.values
            : [...licenseApprovalFilterModel.isManuallyRequested.values, value]
            : licenseApprovalFilterModel.isManuallyRequested.values.filter((val:any) => val !== value)
            dispatch(setLicenseApprovalFilterModel({
                ...licenseApprovalFilterModel,
                isManuallyRequested: {
                    ...licenseApprovalFilterModel.isManuallyRequested,
                    values: updatedFilters
                }
            }));
        } else if (filterType === reviewFiltersHeadings.additional) {
            dispatch(setHideUnnecessaryRejection(isChecked))
        }

    };

    const onDateChange = (fieldName: TransferDateFieldEnum, value: Date | null) => {
        if (!value) return null;
        
        const year = value.getFullYear();
        const month = value.getMonth() + 1; // Convert from 0-indexed to 1-indexed
        const day = value.getDate();
        const date = `${year}-${month}-${day}`;

        if (fieldName === TransferDateFieldEnum.dateFrom) {
            const today = new Date();
            const toDate = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;

            dispatch(setLicenseApprovalFilterModel({
                ...licenseApprovalFilterModel,
                created_date_time: {
                    ...licenseApprovalFilterModel.created_date_time,
                    [fieldName]: date,
                    [TransferDateFieldEnum.dateTo]: toDate
                }
            }));
        } else {
            dispatch(setLicenseApprovalFilterModel({
                ...licenseApprovalFilterModel,
                created_date_time: {
                    ...licenseApprovalFilterModel.created_date_time,
                    [fieldName]: date
                }
            }));
        }
    };

    function setDateRange(dateFrom: Date, dateTo: Date) {
        dispatch(setLicenseApprovalFilterModel({
            ...licenseApprovalFilterModel,
            created_date_time: {
                ...licenseApprovalFilterModel.created_date_time,
                dateFrom: `${dateFrom.getFullYear()}-${dateFrom.getMonth() + 1}-${dateFrom.getDate()}`,
                dateTo: `${dateTo.getFullYear()}-${dateTo.getMonth() + 1}-${dateTo.getDate()}`
            }
        }));
    }

    function handleTodayClick() {
        const today = new Date();
        setDateRange(today, today);
    }

    function handleThisWeekClick() {
        const today = new Date();
        const firstDayOfWeek = new Date(today);
        firstDayOfWeek.setDate(today.getDate() - today.getDay());
        setDateRange(firstDayOfWeek, today);
    }

    function handleThisMonthClick() {
        const today = new Date();
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        setDateRange(firstDayOfMonth, today);
    }

    

    const onResetTransferDate = () => {
        dispatch(setLicenseApprovalFilterModel({
            ...licenseApprovalFilterModel,
            created_date_time: {
                ...licenseApprovalFilterModel.created_date_time,
                dateFrom: null,
                dateTo: null
            }
        }));
    }

    
    useEffect(() => {
        if (
            licenseApprovalFilterModel?.created_date_time?.dateFrom &&
            licenseApprovalFilterModel?.created_date_time?.dateTo &&
            new Date(licenseApprovalFilterModel?.created_date_time?.dateFrom) >
            new Date(licenseApprovalFilterModel?.created_date_time?.dateTo)
        ) {
            setTransferDateError(INVALID_RANGE);
        } else {
            if (
                (!licenseApprovalFilterModel?.created_date_time?.dateFrom &&
                    !licenseApprovalFilterModel?.created_date_time?.dateTo) ||
                (licenseApprovalFilterModel?.created_date_time?.dateFrom &&
                    licenseApprovalFilterModel?.created_date_time?.dateTo)
            ) {
                setTransferDateError('');
            } else {
                setTransferDateError(
                    SELECT_FIELD_DATE.replace(
                        '{{field}}',
                        !licenseApprovalFilterModel?.created_date_time?.dateFrom ? 'start' : 'end'
                    )
                );
            }
        }
    }, [JSON.stringify(licenseApprovalFilterModel?.created_date_time)]);

    return <>
        <Grid
            templateRows='repeat(1, 1fr)'
            templateColumns='repeat(3, 300px)'
            gap={8}
            p={3}
            m={"20px 15px"}
            maxH={"calc(100vh - 290px)"}
            overflow={"auto"}
        >
            <GridItem>
                <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'} mb={4}>
                    {reviewFiltersHeadings.status}
                </Text>
                <CheckboxGroup
                    defaultValue={licenseApprovalFilterModel.status.values}
                >
                    <Stack spacing={[4, 2]} direction={['column']}>
                        {
                            reviewFilters.status.map((val: any) => {
                                if (val.value === "reviewed") return null;
                                const isChecked = licenseApprovalFilterModel.status.values.includes(val.value);
                                return <Checkbox value={val.value} isChecked={isChecked} onChange={(e: any) => handleFilterValues(val.value, isChecked, reviewFiltersHeadings.status)}>{val.label}</Checkbox>;
                            })
                        }
                    </Stack>
                </CheckboxGroup>
                <Grid mt={5}>
                    <GridItem>
                        <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'} mb={4}>
                            {reviewFiltersHeadings.source}
                        </Text>
                        <CheckboxGroup
                            defaultValue={licenseApprovalFilterModel.source.values}
                        >
                            <Stack spacing={[4, 2]} direction={['column']}>
                                {
                                    reviewFilters.source.map((val: any) => {
                                        const isChecked = licenseApprovalFilterModel.source.values.includes(val.value);
                                        return <Checkbox value={val.value} isChecked={isChecked} onChange={(e: any) => handleFilterValues(val.value, isChecked, reviewFiltersHeadings.source)}>{val.label}</Checkbox>;
                                    })
                                }
                            </Stack>
                        </CheckboxGroup>
                    </GridItem>
                </Grid>
                <Grid mt={5}>
                    <GridItem>
                        <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'} mb={4}>
                            {reviewFiltersHeadings.manualReview}
                        </Text>
                        <CheckboxGroup
                            defaultValue={licenseApprovalFilterModel?.isManuallyRequested?.values}
                        >
                            <Stack spacing={[4, 2]} direction={['column']}>
                                {
                                    reviewFilters.isManuallyRequested.map((val: any) => {
                                        const isChecked = licenseApprovalFilterModel?.isManuallyRequested?.values.includes(val.value);
                                        return <Checkbox value={val.value} isChecked={isChecked} onChange={(e: any) => handleFilterValues(val.value, isChecked, reviewFiltersHeadings.manualReview)}>{val.label}</Checkbox>;
                                    })
                                }
                            </Stack>
                        </CheckboxGroup>
                    </GridItem>
                </Grid>
            </GridItem>
            <GridItem>
                <Grid mt={5}>
                    <GridItem>
                        <Box display={'flex'} alignItems={'end'} justifyContent={"space-between"}>
                            <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'}>
                                {reviewFiltersHeadings.createdAt}
                            </Text>
                            <Text fontSize={'14px'} color={'#0090c6'}>
                                <button onClick={onResetTransferDate}>
                                    Reset
                                </button>
                            </Text>
                        </Box>
                        <Text fontSize={'12px'} color={'red'} mb={3}>{transferDateError}</Text>
                        <Box display="flex" className="date-range-wrapper">
                            <div className="date-range-wrapper__item">
                                <FlatDatePickr label="From:" 
                                    onDateChange = {(value) => onDateChange(TransferDateFieldEnum.dateFrom, value)}
                                    value = {
                                        licenseApprovalFilterModel.created_date_time && 
                                        licenseApprovalFilterModel?.created_date_time?.dateFrom &&
                                        licenseApprovalFilterModel?.created_date_time?.dateFrom !== 'null' ? 
                                        new CalendarDate(
                                            parseInt(licenseApprovalFilterModel?.created_date_time?.dateFrom.split('-')[0] as string),
                                            parseInt(licenseApprovalFilterModel?.created_date_time?.dateFrom.split('-')[1] as string),
                                            parseInt(licenseApprovalFilterModel?.created_date_time?.dateFrom.split('-')[2] as string)
                                        ) : null
                                    }
                                    options={{
                                        timeZone : "America/New_York"
                                    }}
                                />
                            </div>
                            <div className="date-range-wrapper__item">
                                <FlatDatePickr label="To:" 
                                    onDateChange = {(value) => onDateChange(TransferDateFieldEnum.dateTo, value)}
                                    value = {
                                        licenseApprovalFilterModel.created_date_time && 
                                        licenseApprovalFilterModel?.created_date_time?.dateTo &&
                                        licenseApprovalFilterModel?.created_date_time?.dateTo !== 'null' ? 
                                        new CalendarDate(
                                            parseInt(licenseApprovalFilterModel?.created_date_time?.dateTo.split('-')[0] as string),
                                            parseInt(licenseApprovalFilterModel?.created_date_time?.dateTo.split('-')[1] as string),
                                            parseInt(licenseApprovalFilterModel?.created_date_time?.dateTo.split('-')[2] as string)
                                        ) : null
                                    }
                                    options={{
                                        timeZone : "America/New_York"
                                    }}
                                />
                            </div>
                            <Box className='flex-row' sx={{ marginTop: '1rem' }}>
                                <Button
                                    className="refresh-btn-queue"
                                    onClick={handleTodayClick}
                                >
                                    Today
                                </Button>
                                <Button
                                    className="refresh-btn-queue"
                                    onClick={handleThisWeekClick}
                                >
                                    This Week
                                </Button>
                                <Button
                                    className="refresh-btn-queue"
                                    onClick={handleThisMonthClick}
                                >
                                    This Month
                                </Button>
                            </Box>
                        </Box>
                    </GridItem>
                </Grid>
                <Grid mt={5}>
                    <GridItem>
                        <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'} mb={4}>
                            {reviewFiltersHeadings.storeType}
                        </Text>
                        <CheckboxGroup
                            defaultValue={licenseApprovalFilterModel.storeType.values}
                        >
                            <Stack spacing={[4, 2]} direction={['column']}>
                                {
                                    reviewFilters.storeType.map((val: any) => {
                                        const isChecked = licenseApprovalFilterModel.storeType.values.includes(val.value);
                                        return <Checkbox value={val.value} isChecked={isChecked} onChange={(e: any) => handleFilterValues(val.value, isChecked, reviewFiltersHeadings.storeType)}>{val.label}</Checkbox>;
                                    })
                                }
                            </Stack>
                        </CheckboxGroup>
                    </GridItem>
                </Grid>
                <Grid mt={5}>
                    <GridItem>
                        <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'} mb={4}>
                            {reviewFiltersHeadings.additional}
                        </Text>
                            <Stack spacing={[4, 2]} direction={['column']}>
                                {
                                    reviewFilters.additional.map((val: any) => {
                                        const isChecked = hideUnnecessaryRejection
                                        return <Checkbox value={val.value} isChecked={isChecked} onChange={(e: any) => handleFilterValues(val.value, e.target.checked, reviewFiltersHeadings.additional)}>{val.label}</Checkbox>;
                                    })
                                }
                                {reviewedStatusOption && (
                                    <Checkbox
                                        value={reviewedStatusOption.value}
                                        isChecked={licenseApprovalFilterModel.status.values.includes(reviewedStatusOption.value)}
                                        onChange={() =>
                                            handleFilterValues(
                                                reviewedStatusOption.value,
                                                licenseApprovalFilterModel.status.values.includes(reviewedStatusOption.value),
                                                reviewFiltersHeadings.status
                                            )
                                        }
                                    >
                                        {reviewedStatusOption.label}
                                    </Checkbox>
                                )}
                            </Stack>
                    </GridItem>
                </Grid>
            </GridItem>
            <GridItem>
                <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'} mb={4}>
                    {reviewFiltersHeadings.faildSteps}
                </Text>
                <CheckboxGroup
                    defaultValue={licenseApprovalFilterModel.faildSteps.values}
                >
                    <Stack spacing={[4, 2]} direction={['column']}>
                        {
                            reviewFilters.faildSteps.map((val: any) => {
                                const isChecked = licenseApprovalFilterModel.faildSteps.values.includes(val.value);
                                return <Checkbox value={val.value} isChecked={isChecked} onChange={(e: any) => handleFilterValues(val.value, isChecked, reviewFiltersHeadings.faildSteps)}>{val.label}</Checkbox>;
                            })
                        }
                    </Stack>
                </CheckboxGroup>
            </GridItem>
            
        </Grid>
    </>
}